<template>
<!-- 我的地址 -->
  <div class="address">
    <ab-list-query :tabs="tabs" @handleSelect="handleSelect" @handleTabs='selectMenu' isActive="0">
      <template #right>
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input
              placeholder="地址编号"
              v-model.trim="formSearch.number"
              clearable
            >
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-input
              placeholder="公司名称"
              v-model.trim="formSearch.companyName"
              clearable
            >
            </el-input>
          </el-col>
          <!-- <el-col :span="4">
            <el-select
              placeholder="地址类型"
              v-model="formSearch.addressType"
              clearable
            >
              <el-option label="收货" value="01"></el-option>
              <el-option label="发货" value="04"></el-option>
            </el-select>
          </el-col> -->
          <el-col :span="4">
            <ab-timeSearch
                v-model="formSearch.timeRange"
                class="searchBox"
                startSrc="创建日期起"
                endSrc="创建日期止"
                @searchEvent="changeTimeRange"
            ></ab-timeSearch>
          </el-col>
          <el-col :span="4" class="text-left">
            <el-button @click="searchForm">搜索</el-button>
            <el-button link class="btn-svg" @click="formSearch={}"
              ><ab-svg name="qingchu"></ab-svg>清除</el-button
            >
          </el-col>
        </el-row>
      </template>

      <template #toolbar>
        <el-button type="primary" @click="addHandlerEdit">新增</el-button>
        <el-button @click="delAddressAll">批量删除</el-button>
        <el-button @click="handleExport" :loading="isExportLoading">导出</el-button>
      </template>

      <template #table>
        <ab-table
          stripe
          showSelection
          class="materialTable"
          ref="table"
          :column-list="columns"
          showEdit
          indexWidth="50"
          widths="180"
          isFilter="operator"
          :dataListLoading="isloading"
          :table-list="tableData"
          @filterColumns="filterColumns"
          :handleSelectionChange="handleSelectionChange"
        >
          <template #addressTypeDesc="scope">
            <div>
              <span
                :class="
                  scope.row.addressTypeDesc == '发货'
                    ? 'status-1165D4'
                    : 'status-0AB2A8'
                "
              >
              </span>
              {{ scope.row.addressTypeDesc }}
            </div>
          </template>

          <template #operator="scope">
            <el-button type="primary" link @click="handlerEdit(scope.row.id)">编辑</el-button>
            <!-- <i class="dividingLine"></i> -->
            <el-button class="redBtn"  link @click="delAddress(scope.row.id)">删除</el-button>
          </template>
        </ab-table>
      </template>

      <template #page>
        <ab-page
          :pageTotal="page.total"
          :currentPage="page.currentPage"
          :pageSize="page.pageSize"
          :pageSizes="page.pageSizes"
          @searchForm="pageSearch"
        ></ab-page>
      </template>
    </ab-list-query>


    <el-drawer v-model="editaddress.show " :destroy-on-close="true" custom-class='address-add' @close="handleClose">
        <template #header>
            <h4 v-if="editOrAdd">新增地址</h4>
            <h4 v-else>修改账号信息</h4>
        </template>

        <el-form :model="editFormSearch" ref="editFormSearch" label-position="top" :rules="editRules" >
            <el-form-item label="适用业务" prop="bizTypeGroup">
                <el-select  v-model="editFormSearch.bizTypeGroup" @change="changeBizTypeGroup" placeholder clearable>
                    <el-option
                        v-for="(option, idx) in typeList.addressBizType"
                        :key="idx"
                        :label="option.desc"
                        :value="option.value"
                        :disabled="checkBizType(option.desc)"
                    ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="地址类型" prop="addressType"  class="addressType">
                <el-select  v-model="editFormSearch.addressType" @change="changeAddressType"  placeholder clearable>
                    <el-option
                        v-for="(option, idx) in typeList.addressType"
                        :key="idx"
                        :label="option.desc"
                        :value="option.value"
                    ></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="联系人" prop="linkMan">
                <el-input  maxLength='50' v-model="editFormSearch.linkMan" placeholder="请输入联系人"></el-input>
            </el-form-item>

            <el-form-item label="联系电话" prop="linkPhone">
                <el-input  maxLength='20' v-model="editFormSearch.linkPhone" placeholder="请输入联系电话"></el-input>
            </el-form-item>

            <el-form-item  label="国家/省/市/区" prop="address">
                <ab-address v-model="editFormSearch.address" @change="changeAddressDesc"></ab-address>
            </el-form-item>

             <el-form-item label="详细地址" prop="addressContent">
                <el-input  v-model="editFormSearch.addressContent"  maxLength="250" placeholder="详细地址"></el-input>
            </el-form-item>

             <el-form-item label="公司名称" prop="companyName">
                <el-input  v-model="editFormSearch.companyName" placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="地址说明" prop="addressExplain">
                <el-select   v-model="editFormSearch.addressExplain" placeholder clearable>
                    <el-option
                    v-for="(option, idx) in editFormSearch.addressType === '01' ? typeList.addressReceive : typeList.addressSend"
                    :key="idx"
                    :label="option.desc"
                    :value="option.value"
                    ></el-option>
                </el-select>
            </el-form-item>

             <el-form-item label="默认地址" prop="isDefault">
                <el-select  placeholder v-model="editFormSearch.isDefault">
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                </el-select>
            </el-form-item>
        </el-form>

        <template #footer>
            <div style="flex: auto">
                <el-button @click="editaddress.show=false">取 消</el-button>
                <el-button type="primary" @click="handlerSave" :loading="editaddress.isloading">确 定</el-button>                
            </div>
        </template>
    </el-drawer>

  </div>
</template>

<script>
export default {
  name: 'my-address',
  data() {
    return {
        editOrAdd:null,//1为新增地址，其余为修改
        tabs: [
            { name: "全部", value: "", state: "0" },
            { name: "发货", value: "", state: "04" },
            { name: "收货", value: "", state: "01" },
        ],
        formSearch: {},
        isloading: false,
        columns: [
            {
            props: "number",
            labels: "地址编号",
            widths: 60,
            },
            {
            props: "createTimeDesc",
            labels: "创建时间",
            widths: 70,
            },
            {
            props: "addressTypeDesc",
            labels: "地址类型",
            widths: 60,
            slot: "slot",
            },
            {
            props: "companyName",
            labels: "公司名称",
            widths: 100,
            },
            {
            props: "addressContent",
            labels: "地址",
            widths: 140,
            },
            {
            props: "addressExplainDesc",
            labels: "地址说明",
            widths: 60,
            },
            {
            props: "isDefaultDesc",
            labels: "默认",
            widths: 40,
            },
        ],
        tableData: [],
        page: {
            currentPage: 1,
            pageSize: 10,
            pageSizes: [10, 20, 50, 100],
            total: 0,
        },
        //编辑相关
        editaddress:{
            show: false,
            isloading:false,
            formSearch:{},
            editLoading:false
        },
        editFormSearch:{},
        //选择器数据
        typeList: {
            addressReceive: [],
            addressBizType: [],
            addressType: [],
            addressSend: []
        },
        roleVos:[],
        receiptAndDelivery:'',
        editRules: {
            bizTypeGroup: [
                {required: true, message: '适用业务不能为空', trigger: ['blur', 'change']}
            ],
            addressType: [
                {required: true, message: '地址类型不能为空', trigger: ['blur', 'change']}
            ],
            addressExplain: [
                {required: true, message: '地址说明不能为空', trigger: ['blur', 'change']}
            ],
            companyName: [
                {required: true, message: '公司名称不能为空', trigger: ['blur', 'change']}
            ],
            linkMan: [
                {required: true, message: '联系人不能为空', trigger: ['blur', 'change']}
            ],
            linkPhone: [
                {required: true, message: '联系电话不能为空', trigger: ['blur']},
                { validator: (rule, value, callback) => {
                    if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(value)) {
                        callback(new Error('电话号码格式错误'))
                    } else if (value.length > 200){
                        callback(new Error('最大支持200位字符长度'))
                    } else {
                        callback()
                    }
                }, trigger: ['blur'] }
            ],
            address: [
                {required: true, message: '地址不能为空', trigger: ['blur', 'change']}
            ],
            addressContent: [
                {required: true, message: '详细地址不能为空', trigger: ['blur', 'change']}
            ],
            isDefault: [
                {required: true, message: '默认地址不能为空', trigger: ['blur', 'change']}
            ]
        },
        //导出按钮
        isExportLoading:false,
        bulkDeletion:[],//批量删除
    };
  },
  watch:{
    editFormSearch(){
     //   this.changeBizTypeGroup()
    }
  },
  methods: {
    filterColumns(array) {
      this.columns = array;
    },
    pageSearch(obj) {
      this.page.currentPage = obj.currentPage;
      this.page.pageSize = obj.pageSize;
      this.getListData();
    },
    handleSelect(val) {},
    //日期
    changeTimeRange (obj) {
        this.formSearch.timeRange=obj
      if (obj) {
        this.formSearch.updateTimeStart = obj[0]
        this.formSearch.updateTimeEnd = obj[1]
      } else {
        this.formSearch.updateTimeStart = ''
        this.formSearch.updateTimeEnd = ''
      }
      this.getListData()
    },
    //请求获取数据
    getListData() {
        this.isloading=true
        let data = Object.assign({data: JSON.parse(JSON.stringify( this.formSearch))}, {pageNum: this.page.currentPage, pageSize: this.page.pageSize})
        //添加收发货请求参数
        // data.data.addressType=this.receiptAndDelivery
        this.$post('/bas/client/basAddress/list', data).then(res => {
          if (res.data.code == 'C0000') {
            this.tableData = res.data.result.list
            this.page.total = res.data.result.total
            //判断不同条件的消息数量
            // this.receiptAndDeliveryNumber(res.data.extra)
          }
        }).finally(() => {
            this.isloading = false
        })
    },
    //搜索
    searchForm(){
        this.getListData()
    },
    //数据编辑
    handlerEdit (id,val) {
        this.editaddress.show = true 
       
            this.editOrAdd=false       
            
            this.editaddress.editLoading=true
            this.$get('/bas/client/basAddress/get', {id: id}).then(res => {
            if (res.data.code == 'C0000') {
                this.editFormSearch = res.data.result
                this.changeAddressType()
                if (typeof this.editFormSearch.addressIds == 'string') {
                    let address = this.editFormSearch.addressIds.split(',')
                    this.editFormSearch.address = []
                    if (address.length > 0) {
                        address.map(e => {
                        this.editFormSearch.address.push(e)
                        })
                    }
                }
                
                // this.fileData.sourceBillId = this.formSearch.id
                // this.fileData.sourceBillNumber = this.formSearch.number
                // this.changeAddressType(true)
                //this.getFileList()
            }
            }).finally(e => {
                this.editaddress.editLoading=false
            })
        
    },
    changeAddressDesc (item, desc) {
        console.log(item, desc);
        this.editFormSearch.areaDesc = desc
    },
    changeBizTypeGroup () {
        if (this.editFormSearch.bizTypeGroup === "01") { //业务类型为进口，地址类型自动选择收货
        this.editFormSearch.addressType='01'
        } else if (this.editFormSearch.bizTypeGroup === "02") { //业务类型为出口， 地址类型自动选择发货
        this.editFormSearch.addressType='04'
        }
    },
    changeAddressType () {
        if (this.editFormSearch.addressType == '01') {
            this.typeList.explainList = this.typeList.addressReceive
        } else {
            this.typeList.explainList = this.typeList.addressSend
        }
    },
    getByUserCenter(){
        this.$get('/p/user/getByUserCenter').then(({data}) => {
        if (data && data.code == 'C0000') {
            this.roleVos = data.result.roleVos
        }
        })
    },
    checkBizType (desc) {
        let flag = true
        this.roleVos.map(e => {
            if (!e.number) {
                return flag
            }
            if (desc == '进口' && (e.number.toLowerCase() === 'client' || e.number.toLowerCase() === 'clienthost')) {
                flag = false
            }
            if (desc == '出口' && e.number.toLowerCase() === 'clientexport') {
                flag = false
            }
        })
        return flag
    },
    //编辑确定
    handlerSave(){
        this.$refs.editFormSearch.validate((valid)=>{
            if(valid){
                let url=''
                if(this.editOrAdd){
                    url='/bas/client/basAddress/add'
                }else{
                    url='/bas/client/basAddress/mod'
                }
                this.editaddress.isloading = true
                this.editFormSearch.addressIds = this.editFormSearch.address.join(',')
                this.$post(url, this.editFormSearch).then(({data}) => {
                    if (data.code == 'C0000') {
                        this.$message({
                            type: 'success',
                            message: data.message,
                            offset: 380,
                            grouping: true,
                        })
                        this.editaddress.isloading = false
                        this.editaddress.show = false   
                        this.getListData()
                    }
                }).finally(() => {
                    this.editaddress.isloading = false
                })
            }
        })
    },
    //删除数据
    delAddress(id) {
        if(typeof id =='string'){
            this.$confirm('确定删除该行数据?','温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                if (id) {
                    this.$post('/bas/client/basAddress/del', {ids: [id]}).then(({ data }) => {
                        if (data.code === 'C0000') {
                            this.$message({
                                type: 'success',
                                message: data.message,
                                offset: 380,
                                grouping: true,
                            })
                            this.getListData()
                        }else{
                            this.$message({
                                type: 'error',
                                message: data.message,
                                offset: 380,
                                grouping: true,
                            })
                        }
                    })
                }
            })
        }else if(typeof id =='object'){
            this.$confirm('确定删除选中数据?','温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                if (id) {
                this.$post('/bas/client/basAddress/del', {ids: [...id]}).then(({ data }) => {
                    if (data.code === 'C0000') {
                        this.$message({
                                type: 'success',
                                message: data.message,
                                offset: 380,
                                grouping: true,
                            })
                        this.getListData()
                        this.bulkDeletion=[]
                    }else{
                        this.$message({
                                type: 'error',
                                message: data.message,
                                offset: 380,
                                grouping: true,
                            })
                    }})
                }
            })
        }
        
    },
    //弹窗关闭清除数据
    handleClose(){
        this.editFormSearch={}
    },
    //新增
    addHandlerEdit(){
        this.editaddress.show=true
        this.editOrAdd=true
    },
    //菜单回调
    selectMenu(index){   
        this.formSearch={}
        this.receiptAndDelivery=''
        this.receiptAndDelivery=index
        this.formSearch.addressType=index
        if(index==0){
            this.receiptAndDelivery=''
            this.formSearch.addressType=''
        } 
        this.getListData()
    },
    receiptAndDeliveryNumber(val){
        this.tabs.forEach(item =>{
            if(item.state == '01'){
                item.value = val['01']
            }else if(item.state == '04'){
                item.value = val['04']
            }else{
                item.value = val['04'] + val['01']
            }
        })
    },
    //导出
    handleExport () {
        this.isExportLoading=true
        console.log(111);
        let excelField = []
        this.columns.map(e => {
            excelField.push(e.props)
        })
        let data = Object.assign(this.formSearch, {excelField},{addressType:this.receiptAndDelivery})
        this.$post('/bas/client/basAddress/export', {data, pageNum: this.page.currentPage, pageSize: this.page.pageSize}).then(res => {
            if (res.data.code == 'C0000') {
            // 创建隐藏的可下载链接
            let eleLink = document.createElement('a')
            eleLink.download = ''
            eleLink.style.display = 'none'
            // 字符内容转变成blob地址
            eleLink.href = res.data.message
            // 触发点击
            document.body.appendChild(eleLink)
            eleLink.click()
            // 然后移除
            document.body.removeChild(eleLink)
            this.isExportLoading=false

            }
        })
    },
    //批量删除
    delAddressAll(){
        this.delAddress(this.bulkDeletion)
    },
    handleSelectionChange(val){
        let arr=[]
        val.forEach((item)=>{
           arr.push(item.id)  
        })
        this.bulkDeletion=arr
    }
  },
  created(){
   
  },
  activated () {
    this.searchForm()
  },
  mounted() {
        this.getByUserCenter()
        this.$post('/bas/client/basAddress/typeList').then(res => {
            if (res.data.code == 'C0000') {
                this.typeList.addressReceive  = res.data.result.addressReceive
                this.typeList.addressType  = res.data.result.addressType
                this.typeList.addressSend = res.data.result.addressSend
                this.typeList.addressBizType  = res.data.result.addressBizType
                if (this.typeList.addressBizType && this.typeList.addressBizType.length === 1) { //2021-3-29 业务类型取值改成取全局的，不再从委托方获取
                    this.formSearch.bizTypeGroup = this.typeList.addressBizType[0].value
                }
            }
        })
    },

};
</script>

<style lang='scss'>
.address {
  .dividingLine {
    display: inline-block;
    width: 1px;
    height: 10px;
    background-color: #bfbfbf;
    margin: 0 5px;
  }
  .redBtn {
    margin-left: 10px !important;
  }
    .addressType{
        .el-input{
            height: 45px;
        }
    }

  .address-add{
    border-radius: 16px;
    //滚动条的宽度
    ::-webkit-scrollbar {
        width: 8px;        
    }
    //滚动条的滑块
    ::-webkit-scrollbar-thumb {
        background-color: #aaa;
        border-radius: 3px;
        &:hover {
            background: #999;
        }
    }
    .el-form-item{
        margin-bottom: 27px;
    }
    header {
      color: #000;
      margin-bottom: 20px;
      text-align: left;
      padding: 20px 40px 0 40px;
      h4 {
        font-size: 18px;
        font-weight: 400;
      }
    }
    .el-drawer__body{
        padding: 20px 40px;
    }
    .el-form-item__label{
        color: #000;
    }
    .el-drawer__footer {
      text-align: center;
    }
  }
}
</style>